import { createGlobalStyle } from 'styled-components';

export const MapPopupGlobalStyle = createGlobalStyle`
  .map-popup-container {
    position: absolute;
    pointer-events: auto;
    z-index: 1;
    will-change: transform;
    transition: opacity 0.2s ease;
  }

  .map-popup-bubble {
    position: relative;
    background-color: white;
    padding: 0;
    border-radius: 12px;
    border: 1px solid #ccc;
    box-shadow: 0 2px 6px rgba(0,0,0,0.3);
    font-family: Arial, sans-serif;
    font-size: 14px;
    overflow: hidden;
    pointer-events: auto;
    min-width: 220px;
    max-width: 360px;
    width: auto;
    margin-bottom: 0;
  }

  /* a11y: show teal border when container has focus, focus-within, or hover-active class */
  .map-popup-container:focus .map-popup-bubble,
  .map-popup-container.focus-within .map-popup-bubble,
  .map-popup-container.hover-active .map-popup-bubble {
    border: 2px solid #007a70; /* Teal border for a11y */
  }

  /* HP-7386: Hide pinned popup while hovering a different marker */
  .map-popup-container.popup-suppressed {
    display: none !important;
  }

  /* Show close button only when the popup is pinned (clicked/active) */
  .map-popup-container.popup-pinned .popup-close-button {
    display: block !important;
  }

  /* Style for the close button when focused */
  .map-popup-container button:focus {
    outline: 2px solid #007a70;
    outline-offset: 2px;
  }

  /* When close button is focused, remove teal border from popup */
  .popup-close-button:focus + div .map-popup-bubble,
  .popup-close-button:focus ~ .map-popup-bubble {
    border-color: #ccc !important;
  }

  .map-popup-bubble-anchor {
    position: absolute;
    width: 100%;
    bottom: 0;
    left: 0;
  }

  /* Bottom triangle for popup info modal */
  .map-popup-bubble-anchor::after {
    content: "";
    position: absolute;
    bottom: -18px;
    left: 50%;
    transform: translateX(-50%);
    border-left: 16px solid transparent;
    border-right: 16px solid transparent;
    border-top: 20px solid white;
    box-shadow: none;
    display: block !important;
    visibility: visible !important;
    z-index: 2;
  }

  /* Add teal border to triangle when popup has focus or hover */
  .map-popup-container:focus .map-popup-bubble-anchor::after,
  .map-popup-container.focus-within .map-popup-bubble-anchor::after,
  .map-popup-container.hover-active .map-popup-bubble-anchor::after {
    /* Create a second triangle that acts as the border */
    border-top-color: #007a70;
  }

  /* Create a white inner triangle to maintain the pointer appearance */
  .map-popup-container:focus .map-popup-bubble-anchor::before,
  .map-popup-container.focus-within .map-popup-bubble-anchor::before,
  .map-popup-container.hover-active .map-popup-bubble-anchor::before {
    content: "";
    position: absolute;
    bottom: -16px;
    left: 50%;
    transform: translateX(-50%);
    border-left: 14px solid transparent;
    border-right: 14px solid transparent;
    border-top: 18px solid white;
    display: block !important;
    visibility: visible !important;
    z-index: 3;
  }

  .map-popup-content {
    display: flex;
    flex-direction: column;
  }

  .map-popup-photo {
    width: 100%;
    height: 140px;
    object-fit: cover;
    display: block;
    flex-shrink: 0;
  }

  .map-popup-text {
    padding: 8px;
  }

  .map-popup-info-block {
    margin-bottom: 6px;
  }

  .map-popup-address-block {
    margin-bottom: 6px;
  }

  .map-popup-address {
    font-size: 14px;
    word-wrap: break-word;
    color: #555;
    line-height: 1.2;
  }

  .map-popup-price-row {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .map-popup-price {
    font-weight: bold;
    font-size: 16px;
  }

  .map-popup-details {
    font-size: 14px;
    margin-bottom: 4px;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 4px;
  }

  .map-popup-detail-value {
    font-weight: 600;
    color: #212a3b; /* hpxBlue600 */
  }

  .map-popup-detail-label {
    color: #949494; /* hpxGrey500 */
    font-weight: 400;
  }

  .map-popup-detail-sep {
    color: #949494; /* hpxGrey500 */
  }

  .map-popup-badge {
    display: flex;
    align-items: center;
  }
`;
